import React, { useState } from "react";
import { Col, Container, Row, Modal } from "react-bootstrap";
import Carousel from "react-bootstrap/Carousel";
import Img1 from "../../../images/landing/client_img1.webp";
import Img2 from "../../../images/landing/client_img2.webp";
import Img3 from "../../../images/landing/client_img3.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";

const Clientwork = () => {
  const [show, setShow] = useState(false);
  const [video, setVideo] = useState("");

  const handleClose = () => setShow(false);
  const handleShow = (videoUrl) => {
    setShow(true);
    setVideo(videoUrl);
  };

  return (
    <section className="client_work_lp p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={10}
            xl={10}
            xxl={10}
            className="text-center m-auto"
          >
            <h2>Our Clients Love Our Work!</h2>
          </Col>
        </Row>
        <Row>
          <Carousel indicators={false} interval={3000} pause={false} className="client_landing_slider">
            <Carousel.Item>
              <Row>
                <Col xs={12} md={6} lg={6} xl={5} xxl={5} className="my-auto">
                  <div className="client_content">
                    <h3>Bob Gamon</h3>
                    <span>TalPool Holdings, Founder</span>
                    <p>
                      “They have been instrumental in developing our application
                      and website and their experience is unsurpassable"
                    </p>
                  </div>
                </Col>
                <Col
                  xs={12}
                  md={6}
                  lg={6}
                  xl={6}
                  xxl={6}
                  className="my-auto offset-xl-1"
                >
                  <LazyLoadImage
                    src={Img1}
                    effect="blur"
                    alt="tekrevol_clutch"
                    className="img-fluid"
                    onClick={() =>
                      handleShow("https://www.youtube.com/embed/VFn3HLQpd7I")
                    }
                  />
                </Col>
              </Row>
            </Carousel.Item>
            <Carousel.Item>
              <Row>
                <Col xs={12} md={6} lg={6} xl={5} xxl={5} className="my-auto">
                  <div className="client_content">
                    <h3>Cristina Cabrera </h3>
                    <span>The Veteran App, Co-Founder</span>
                    <p>
                      “Tekrevol has been amazing…it’s a very big project so they
                      break it down into chunks and just perform. I can’t
                      recommend them enough.”
                    </p>
                  </div>
                </Col>
                <Col
                  xs={12}
                  md={6}
                  lg={6}
                  xl={6}
                  xxl={6}
                  className="my-auto offset-xl-1"
                >
                  <LazyLoadImage
                    src={Img2}
                    effect="blur"
                    alt="tekrevol_clutch"
                    className="img-fluid"
                    onClick={() => handleShow("https://www.youtube.com/embed/j0SYqokb6MQ")}
                  />
                </Col>
              </Row>
            </Carousel.Item>
            <Carousel.Item>
              <Row>
                <Col xs={12} md={6} lg={6} xl={5} xxl={5} className="my-auto">
                  <div className="client_content">
                    <h3>Michael Oz</h3>
                    <span>Oz Leasing, Owner</span>
                    <p>
                      “These guys are amazing...they’re very responsive…truly
                      the best experience I’ve had”
                    </p>
                  </div>
                </Col>
                <Col
                  xs={12}
                  md={6}
                  lg={6}
                  xl={6}
                  xxl={6}
                  className="my-auto offset-xl-1"
                >
                  <LazyLoadImage
                    src={Img3}
                    effect="blur"
                    alt="tekrevol_clutch"
                    className="img-fluid"
                    onClick={() => handleShow("https://www.youtube.com/embed/VLRMD0wUhLU")}
                  />
                </Col>
              </Row>
            </Carousel.Item>
          </Carousel>
        </Row>
      </Container>
      <Modal
        show={show}
        onHide={handleClose}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="client_lp_video"
      >
        <iframe
          width="100%"
          src={video} 
          title="Client Testimonial"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </Modal>
    </section>
  );
};

export default Clientwork;
